import "./ApplicantsCard.css";
import React from "react";
import user_avatar from "../images/user.png";
import { Button } from "@mui/material";
import { useSelector } from "react-redux";
import { ResumeDownload } from "../../utilities/apis";


const ApplicantsCard = ({applicantDetails}) => {

  const selectUserID = useSelector((state=>state.user.userID))

  let skillsArray = [];
  console.log("Data Type: ", typeof(applicantDetails.skills))
  if(typeof(applicantDetails.skills)==="string"){
    skillsArray = applicantDetails.skills.split(",");
  }else{
    skillsArray =applicantDetails.skills
  }
  
  const skillsBadge = (
    <div className="skills-container">
      {skillsArray.map((skills, index) => {
        return <div className="skill-badge">{skills}</div>;
      })}
    </div>
  );  

  
  async function handleDownloadClk(){
    try{
      const resumeRes = await ResumeDownload(applicantDetails.email)
      if(resumeRes.success){
        console.log("Resume: ",resumeRes);
      }
    }catch(error){
      console.log("Error downloading the file.")
    }
    
  }


  return (
    <div className="aplcnt-card">
      <div className="aplcnt-column1">
        <img className="aplcnt-pic" src={user_avatar}></img>
        <p className="aplcnt-name">{applicantDetails.name}</p>
        <p className="aplcnt-loc">Location</p>
      </div>
      <div className="aplcnt-column2">
        <div className="aplcnt-qual">
          <div className="aplcnt-qual-title">Course Name</div>
          <div className="aplcnt-qual-insttution">Institution</div>
        </div>
        <div className="aplcnt-skills">{skillsBadge}</div>
      </div>
      <div className="aplcnt-column3">
        <div className="aplcnt-currentjob">Current Job</div>
        <div className="aplcnt-experience">Experience</div>
        <div className="aplcnt-notice-prd">Last working day</div>
      </div>
      <div className="aplcnt-column4">
        <Button className="aplcnt-shortlist-btn">Shortlist</Button>
        <Button className="aplcnt-reject-btn">Reject</Button>
        <Button className="aplcnt-contact-btn" onClick={handleDownloadClk}>Download</Button>
      </div>
    </div>
  );
};

export default ApplicantsCard;
